import { OverlayShellConfig } from "../../shared/overlay-shell/overlay.models";

export const EDIT_EMPLOYEE_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: true,
  width: "1390px",
  height: "870px",
};
